import { useState } from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Modal from "components/ModalReact";

const Icon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.text};
`;

const InfoModal = ({ ...restProps }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);

  return (
    <div {...restProps}>
      <Icon
        className="ms-2"
        type="button"
        icon={faInfoCircle}
        onClick={() => setShow(true)}
      />
      <Modal size="xl" show={show} handleClose={handleClose}>
        <Modal.Header handleClose={handleClose}>
          <Modal.Title>Severity legend</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginTop: "20px", marginBottom: "40px" }}>
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
                margin: "0 auto",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      backgroundColor: "#0d1116",
                      border: "1px solid #0d1116",
                    }}
                  >
                    Score
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "#0d1116",
                      border: "1px solid #0d1116",
                    }}
                  >
                    Level
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      backgroundColor: "#0d1116",
                      border: "1px solid #0d1116",
                    }}
                  >
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "#ee6352",
                      color: "white",
                      border: "1px solid #0d1116",
                    }}
                  >
                    <b>1</b>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      border: "1px solid #0d1116",
                    }}
                  >
                    Critical
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      border: "1px solid #0d1116",
                      textAlign: "left",
                    }}
                  >
                    Critical vulnerabilities identified, requiring immediate
                    action.
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "#f9a620",
                      color: "white",
                      border: "1px solid #0d1116",
                    }}
                  >
                    <b>2</b>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      border: "1px solid #0d1116",
                    }}
                  >
                    High
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      border: "1px solid #0d1116",
                      textAlign: "left",
                    }}
                  >
                    Significant vulnerabilities found, requiring prompt
                    attention.
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "#ffd449",
                      color: "white",
                      border: "1px solid #0d1116",
                    }}
                  >
                    <b>3</b>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      border: "1px solid #0d1116",
                    }}
                  >
                    Medium
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      border: "1px solid #0d1116",
                      textAlign: "left",
                    }}
                  >
                    Moderate vulnerabilities present, requiring corrections in
                    the medium term.
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "#32de8a",
                      color: "white",
                      border: "1px solid #0d1116",
                    }}
                  >
                    <b>4</b>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      border: "1px solid #0d1116",
                    }}
                  >
                    Low
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      border: "1px solid #0d1116",
                      textAlign: "left",
                    }}
                  >
                    Minor vulnerabilities requiring monitoring and corrections
                    within a reasonable time.
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      backgroundColor: "#45a1ee",
                      color: "white",
                      border: "1px solid #0d1116",
                    }}
                  >
                    <b>5</b>
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      border: "1px solid #0d1116",
                    }}
                  >
                    No Risk
                  </td>
                  <td
                    style={{
                      padding: "10px",
                      border: "1px solid #0d1116",
                      textAlign: "left",
                    }}
                  >
                    No vulnerabilities or risks detected.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default InfoModal;
